import { render } from "./PageSectionField.vue?vue&type=template&id=b3f8d17c&scoped=true"
import script from "./PageSectionField.vue?vue&type=script&lang=js"
export * from "./PageSectionField.vue?vue&type=script&lang=js"

import "./PageSectionField.vue?vue&type=style&index=0&id=b3f8d17c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f8d17c"]])

export default __exports__